export const isValidSimpleUrl = (url) => {
    return /^https:\/\/[a-zA-Z0-9.-]+\.com(\/.*)?$/.test(url);
};